module.exports = __webpack_public_path__ + "img/C08.49590f21.gif";